import { FormType } from './editingTypes';

export const InitialFormData: FormType = {
    id: undefined,
    name: '',
    apps: [],
    formats: []
}